import React from "react";
import { useTranslation } from "react-i18next";

/**
 * `message` is a translation key, or `{ key, params }` when the text needs
 * values, so an open toast follows a language change too.
 */
export default function Toast({ isOpen, message }) {
  const { t } = useTranslation();
  if (!isOpen || !message) {
    return null;
  }

  const text = typeof message === "string" ? t(message) : t(message.key, message.params);

  return (
    <div className="toast-notification" role="status" aria-live="polite">
      <div className="toast-content">{text}</div>
    </div>
  );
}
